import { styled } from 'styled-components';
import { dontForwardProps } from '../../util';
export const Container = styled.div.withConfig({
  componentId: "aui__sc-1d27hvz-0"
})(["display:grid;"]);
export const LoadingContainerBase = styled.div.withConfig({
  componentId: "aui__sc-1d27hvz-1"
})(["grid-column:1;grid-row:1;place-self:center;display:flex;justify-content:center;align-items:center;"]);
export const NotLoadingContainer = styled(LoadingContainerBase).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1d27hvz-2"
})(["visibility:", ";"], ({
  isLoading
}) => isLoading ? 'hidden' : 'visible');
export const LoadingContainer = styled(LoadingContainerBase).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1d27hvz-3"
})(["visibility:", ";"], ({
  isLoading
}) => isLoading ? 'visible' : 'hidden');